// utils/dataExportUtils.js

import { jsPDF } from 'jspdf';
import * as XLSX from 'xlsx';
import React from 'react';

// Function for exporting data to PDF
export const downloadPDF = (columnsData, columnVisibility, data) => {
  const doc = new jsPDF();
  const visibleColumns = columnsData
    .filter((col) => columnVisibility[col.id])
    .map((col) => col.header);

  const dataToExport = data.map((row) =>
    visibleColumns.map(
      (header) => row[columnsData.find((col) => col.header === header).id],
    ),
  );

  doc.autoTable({
    head: [visibleColumns],
    body: dataToExport,
  });

  doc.save('data.pdf');
};

// Function for exporting data to Excel
export const downloadExcel = (columnsData, columnVisibility, data) => {
  const workbook = XLSX.utils.book_new();

  const visibleColumns = columnsData
    .filter((col) => columnVisibility[col.id])
    .map((col) => col.header);

  const dataToExport = data.map((row) =>
    visibleColumns.map(
      (header) => row[columnsData.find((col) => col.header === header).id],
    ),
  );

  const worksheetData = [visibleColumns, ...dataToExport];

  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

  XLSX.writeFile(workbook, 'data.xlsx');
};

export const useServerPagination = (totalCount) => {
  const [pageSize, setPageSize] = React.useState(10);
  const [currentPage, setCurrentPage] = React.useState(0);

  // Calculate total pages based on total count from API
  const totalPages = React.useMemo(() => {
    if (pageSize === 'ALL') return 1;
    if(pageSize === 0) return 0;
    return Math.ceil(totalCount / pageSize);
  }, [totalCount, pageSize]);

  // Handle page size changes from the Select component
  const handlePageSizeChange = (event) => {
    const value = event.target.value;
    if (value === 'ALL') {
      setPageSize(totalCount);
    } else {
      setPageSize(parseInt(value, 10));
    }
    setCurrentPage(0); // Reset to first page when changing page size
  };

  // Handle page navigation
  const handlePageChange = (direction) => {
    if (pageSize === 'ALL') return;

    setCurrentPage((prev) => {
      if (direction === 'next') {
        return Math.min(prev + 1, totalPages - 1);
      } else {
        return Math.max(prev - 1, 0);
      }
    });
  };

  // Reset page when search changes
  const resetPage = React.useCallback(() => {
    setCurrentPage(0);
  }, []);

  // Get current pagination parameters for API request
  const getPaginationParams = () => ({
    page: currentPage + 1, // Convert to 1-based for API
    // limit: pageSize === 'ALL' ? totalCount : pageSize,
  });

  return {
    handlePageSizeChange,
    handlePageChange,
    resetPage,
    totalPages,
    currentPage,
    pageSize,
    getPaginationParams,
  };
};
export const usePagination = (data, filteredData) => {
  const [pageSize, setPageSize] = React.useState(10);
  const [currentPage, setCurrentPage] = React.useState(1);

  // const paginatedData = React.useMemo(() => {
  //   if (pageSize === filteredData.length || pageSize === 'ALL') {
  //     return filteredData; // Show all data if page size is 'ALL'
  //   }
  //   const start = currentPage * pageSize;
  //   const end = Math.min(start + pageSize, filteredData.length);
  //   return filteredData.slice(start, end);
  // }, [filteredData, currentPage, pageSize]);

  // const totalPages = React.useMemo(() => {
  //   if (pageSize === filteredData?.length) return 1;
  //   // if (filteredData?.length > pageSize ) return 1;
  //   return Math.ceil(filteredData?.length / pageSize);
  // }, [filteredData.length, pageSize]);
  
  const handlePageSizeChange = (event) => {
    const value = event.target.value;

    setPageSize(value === 'ALL' ? filteredData?.length : parseInt(value, 10));

    // const newPageSize = value === 'ALL' ? filteredData?.length : parseInt(value, 10);

    // setPageSize(newPageSize);
    setCurrentPage(0); // Reset to first page when changing page size
  };
  
  // const handlePageSizeChange = (event) => {
  //   const value = event.target.value;
  //   if (value === 'ALL') {
  //     setPageSize(totalCount);
  //   } else {
  //     setPageSize(parseInt(value, 10));
  //   }
  //   setCurrentPage(0); // Reset to first page when changing page size
  // };
  const handlePageChange = (direction) => {
    setCurrentPage((currentPage) => {
      if (direction === 'next') {
        return Math.min(currentPage + 1, totalPages - 1);
      } else {
        return Math.max(currentPage - 1, 0);
      }
    });
  };
  
  const paginatedData = React.useMemo(() => {
    if (pageSize === filteredData?.length) return filteredData;
    const start = currentPage * pageSize;
    const end = Math.min(start + pageSize, filteredData?.length);
    return filteredData?.slice(start, end);
  }, [filteredData, currentPage, pageSize]);



  const totalPages =
    pageSize === filteredData?.length
      ? 1
      : Math.ceil(filteredData?.length / pageSize);


  

  const getPaginationParams = () => ({
    page: currentPage + 1, // Convert to 1-based for API
    // limit: pageSize === 'ALL' ? filteredData?.length : pageSize,
  });

  return { 
    paginatedData, 
    handlePageSizeChange, 
    handlePageChange, 
    totalPages, 
    pageSize,
    currentPage, 
    getPaginationParams, 
  };
};

// Function for filtering data based on a search query
export const useFilterData = (data, searchQuery, columnsData) => {
  return React.useMemo(() => {
    if (!searchQuery) return data;
    return data?.filter((row) =>
      columnsData?.some((col) =>
        String(row[col.id]).toLowerCase().includes(searchQuery.toLowerCase()),
      ),
    );
  }, [data, searchQuery, columnsData]);
};
